import React from 'react';
import { cn } from '@/lib/utils';
import { useIsMobile } from '@/hooks/useIsMobile';

const ResponsiveDataList = ({
  items = [],
  renderCard,
  children,
  empty,
  className,
  mobileClassName,
  desktopClassName,
}) => {
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <div className={cn('space-y-3', className, mobileClassName)} data-responsive-list-mobile>
        {items.length === 0 ? empty : items.map(renderCard)}
      </div>
    );
  }

  return (
    <div className={cn('block', desktopClassName)}>
      {children}
    </div>
  );
};

export default ResponsiveDataList;
